/**
 * <s-color-peek> — lets a product card switch to a chosen shirt color.
 *
 * Wraps a product card. <s-color-switcher> calls showColor(name) to swap the card's image
 * to that color and point the card links at the matching variant. No hover behavior.
 *
 * Required markup:
 *   data-colors — JSON array of {"name": string, "id": number, "url": string} (see snippets/color-peek-colors.liquid).
 */
class SColorPeek extends HTMLElement {
  #colors = [];
  #img = null;

  connectedCallback() {
    try {
      this.#colors = JSON.parse(this.dataset.colors || '[]');
    } catch {
      this.#colors = [];
    }
    this.#img = this.querySelector('img');
  }

  /**
   * Makes `name` the card's color: swaps the image and points the card links at that variant.
   * Cards without that color are left unchanged.
   */
  showColor(name) {
    if (!this.#img) return;
    const color = this.#colors.find((entry) => entry.name === name);
    if (!color) return;

    this.#img.removeAttribute('srcset');
    this.#img.src = color.url;

    if (color.id) {
      for (const link of this.querySelectorAll('a[href]')) {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.set('variant', String(color.id));
        link.setAttribute('href', url.pathname + url.search);
      }
    }
  }
}

if (!customElements.get('s-color-peek')) {
  customElements.define('s-color-peek', SColorPeek);
}
